import { usePermissions, useProjectCapabilities } from '@/entities/user';

/**
 * Mirrors `AssetWorkflowsService.resolveActor`. Diverging from it puts an approve
 * button in front of someone the API will refuse.
 *
 * Only an organization admin passes on the token alone: its workspace-admin flag holds for an
 * admin of any workspace in the organization. The project's capabilities already carry what an
 * admin of this project's own workspace inherits.
 */
export function useApprovalOverride(): boolean {
  const { isOrganizationAdmin } = usePermissions();
  const { canEditDetails, canManageMembers } = useProjectCapabilities();

  return isOrganizationAdmin || (canEditDetails && canManageMembers);
}
